import { ICookieOptions, setCookie } from '@cian/utils/lib/browser/cookie';
import {
  MORTGAGE_RATE_HIKE_BANNER_CLOSED_COOKIE_NAME,
  MORTGAGE_RATE_HIKE_BANNER_CLOSED_COOKIE_VALUE,
} from 'shared/constants/mortgageRateHikeBanner';

/** 400 дней — максимальный срок жизни куки в Chrome */
const MORTGAGE_RATE_HIKE_BANNER_COOKIE_EXPIRES = 400 * 86400;

export function setMortgageRateHikeBannerClosedCookie(): void {
  const cookieConfig: ICookieOptions = { expires: MORTGAGE_RATE_HIKE_BANNER_COOKIE_EXPIRES, secure: false };

  setCookie(MORTGAGE_RATE_HIKE_BANNER_CLOSED_COOKIE_NAME, MORTGAGE_RATE_HIKE_BANNER_CLOSED_COOKIE_VALUE, cookieConfig);
}
